import React from "react";
import { ChartTypes, WidgetTypes } from "../../../../constants/action-types";
import { getChartIcon } from "./chartUtils";

interface ChartTypeTabsProps {
  type: string;
  chartType: string;
  objectType: string;
  onChartTypeChange: (type: string, chartType: string, objectType: string) => void;
}

const ChartTypeTabs: React.FC<ChartTypeTabsProps> = ({
  type,
  chartType,
  objectType,
  onChartTypeChange,
}) => {
  const isSale = objectType === "SALE";

  const chartTypeItems: Array<{
    label: string;
    type: string;
    chartType: string;
  }> = [
    { label: "Line", type: WidgetTypes.chart, chartType: ChartTypes.line },
    { label: "Bar", type: WidgetTypes.chart, chartType: ChartTypes.bar },
    { label: "Column", type: WidgetTypes.chart, chartType: ChartTypes.column },
    { label: "Pie", type: WidgetTypes.chart, chartType: ChartTypes.pie },
    { label: "Number", type: WidgetTypes.scorecard, chartType: ChartTypes.bar },
    ...(isSale ? [{ label: "Goal", type: WidgetTypes.goal, chartType: ChartTypes.bar }] : []),
    { label: "Table", type: WidgetTypes.grid, chartType: ChartTypes.bar },
  ];

  return (
    <div className="flex gap-2.5 w-full">
      {chartTypeItems.map((item) => (
        <button
          key={item.label}
          onClick={() => {
            onChartTypeChange(item.type, item.chartType, objectType);
          }}
          className={`flex items-center justify-center gap-2 px-3 py-2 text-sm font-medium rounded-lg flex-1 ${
            type === item.type && chartType === item.chartType
              ? "bg-blue-600 text-white"
              : "text-gray-800 hover:bg-gray-50"
          }`}
        >
          {getChartIcon(
            item.type as any,
            item.chartType as any,
            type === item.type && chartType === item.chartType ? "text-white" : "text-gray-800"
          )}
          {item.label}
        </button>
      ))}
    </div>
  );
};

export default ChartTypeTabs;
